export default __webpack_public_path__ + "static/media/lap_image2.b7f08c99.jfif";